<template>
  <div id="header-component">
    <v-card id="header-card" class="overflow-hidden rounded-0" elevation="5">
      <v-progress-linear color="#C850C0" indeterminate height="2" absolute v-show="loading"></v-progress-linear>
      <v-app-bar color="#353535" height="50" align="center" dark>
        <v-app-bar-nav-icon @click="mainDrawer = !mainDrawer"></v-app-bar-nav-icon>
        <v-toolbar-title class="d-flex align-center">
          <PanelBrand />
        </v-toolbar-title>
        <v-spacer />
        <v-btn icon @click="systemDrawer = !systemDrawer">
          <v-icon size="1.2rem">mdi-cog</v-icon>
        </v-btn>
        <v-tooltip bottom color="primary">
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-on="on" v-bind="attrs" icon medium @click="logout">
              <v-icon size="1.2rem">mdi-power</v-icon>
            </v-btn>
          </template>
          <span>{{ $t("PANEL.HEADER.LOGOUT") }}</span>
        </v-tooltip>
      </v-app-bar>
      <v-navigation-drawer v-model="mainDrawer" fixed temporary dark>
        <v-list>
          <v-list-item :to="'/'">
            <v-icon left size="25">mdi-home</v-icon>
            {{ $t("PANEL.HEADER.HOME") }}
          </v-list-item>
          <div :key="key" v-for="(nav, key) in panelNavigation.child">
            <v-list-item v-if="nav.child.length === 0 || navChildsLength(nav.child) === 0" :to="`${panelNavigation.link}/${nav.link}`" v-show="nav.icon !== ''" link>
              <v-icon left outlined>{{ nav.icon }}</v-icon>
              {{ nav.name }}
            </v-list-item>
            <v-list-group v-else class="white--text" active-class="cheetah-list-group--active" v-show="nav.icon !== ''">
              <template v-slot:activator>
                <v-list-item-title class="white--text">
                  <v-icon class="mr-2" outlined>{{ nav.icon }}</v-icon>
                  <span class="white--text">{{ nav.name }}</span>
                </v-list-item-title>
              </template>
              <v-list-item
                class="pl-6 primary lighten-1 white--text"
                :key="childKey"
                v-for="(child, childKey) in nav.child"
                :to="`${panelNavigation.link}/${nav.link}/${child.link}`"
                v-show="child.icon !== ''"
                link
              >
                <v-icon left outlined>{{ child.icon }}</v-icon>
                {{ child.name }}
              </v-list-item>
            </v-list-group>
          </div>
          <div :key="key" v-for="(nav, key) in panelNavigationExtend.child">
            <v-list-item
              :to="`${panelNavigationExtend.link}/${nav.link}`"
              v-if="nav.child.length === 0 || navChildsLength(nav.child) === 0"
              v-show="nav.icon !== ''"
              link
            >
              <v-icon left outlined>{{ nav.icon }}</v-icon>
              {{ nav.name }}
            </v-list-item>
          </div>
        </v-list>
      </v-navigation-drawer>
      <!--   System Drawer   -->
      <v-navigation-drawer v-model="systemDrawer" fixed temporary right>
        <v-list>
          <!--          <div :key="key" v-for="(nav, key) in panelSettings.child">-->
          <!--            <v-list-item v-if="nav.child.length === 0 || navChildsLength(nav.child) === 0" :to="`${panelNavigation.link}/${nav.link}`" v-show="nav.icon !== ''" link>-->
          <!--              <v-icon left outlined>{{ nav.icon }}</v-icon>-->
          <!--              {{ nav.name }}-->
          <!--            </v-list-item>-->
          <!--          </div>-->
          <v-list-item v-for="(item, index) in panelSettings.child" :key="index" v-ripple class="px-2">
            <v-hover v-slot:default="{ hover }">
              <v-list-item-title class="panel-nav-items" :class="hover ? 'nav-is-hover' : ''">
                <RouterLink class="panel-nav-a-items text-body-2" :to="`${panelSettings.link}/${item.link}`">
                  <v-icon class="mr-2">{{ item.icon }}</v-icon>
                  {{ item.name }}
                </RouterLink>
              </v-list-item-title>
            </v-hover>
          </v-list-item>
        </v-list>
      </v-navigation-drawer>
      <!--   ./System Drawer   -->
    </v-card>
    <BreadCrumbs />
  </div>
</template>

<script>
import BreadCrumbs from "@/components/Template/BreadCrumbs";
import { mapState } from "vuex";
import PanelBrand from "@/components/Template/PanelBrand.vue";
import HeaderManagement from "@/components/Template/HeaderManagement.vue";

export default {
  name: "Mobile",
  components: {
    BreadCrumbs,
    PanelBrand,
    HeaderManagement
  },
  data(vm) {
    return {
      extendNavigation: vm.isExtendNav(),
      systemSettingsMenu: false,
      mainDrawer: false,
      systemDrawer: false
    };
  },
  computed: {
    ...mapState({
      loading: state => state.loadingStatus,
      panelNavigation: state => state.panelNavigation,
      panelNavigationExtend: state => state.panelNavigationExtend,
      widgetsLists: state => state.Widget.WidgetLists.widgetLists,
      panelSettings: state => state.panelSettings
    })
  },
  methods: {
    navChildsLength(child) {
      let navs = Object.keys(child).filter(n => child[n].icon !== "");
      return navs.length;
    },
    isExtendNav() {
      return (this.extendNavigation = localStorage.getItem("nav-extend") ? true : false);
    },
    navExtend() {
      let extStatus = this.isExtendNav();
      if (extStatus) {
        localStorage.removeItem("nav-extend");
      } else {
        localStorage.setItem("nav-extend", 1);
      }
      this.isExtendNav();
    },
    logout: function() {
      this.$store.dispatch("User/UserLogin/authLogout").then(() => {
        window.location.replace("login");
      });
    }
  }
};
</script>

<style>
.cheetah-list-group--active {
  color: white !important;
}
</style>
